import { Card, Col, Row } from 'reactstrap';
import { toLocaleFormatSlash } from '../../../helpers/dateFormat';

interface LoaDetailsInfoProps {
  workerName?: string;
  firstDayOfLoa?: string;
  lastDayOfLoa?: string;
  actualStartDate?: string;
  actualEndDate?: string;
  typeOfLoa?: string;
  selectedReason?: string;
  reason?: string;
  additionalNotes?: string;
  documents?: any[];
  loaPolicy?: string;
  accrual?: boolean;
  paymentPct?: number;
  recordNumber?: number;
  isMostRecent?: boolean;
}

const LoaDetailsInfo = ({
  workerName,
  firstDayOfLoa,
  lastDayOfLoa,
  actualStartDate,
  actualEndDate,
  selectedReason,
  reason,
  additionalNotes,
  documents,
  loaPolicy,
  accrual,
  paymentPct,
  recordNumber,
  isMostRecent,
}: LoaDetailsInfoProps) => {
  const InfoRow = ({ label, value }: { label: string; value: string }) => (
    <div className="mb-2 pb-2" style={{ borderBottom: '1px solid #dddddd' }}>
      <div className="text-muted" style={{ fontSize: '0.85rem', marginBottom: '4px' }}>
        {label}
      </div>
      <div style={{ fontSize: '0.95rem', fontWeight: '500' }}>{value}</div>
    </div>
  );

  return (
    <Card style={{ padding: '30px 40px', background: '#eaeaff' }}>
      <Row className="mb-3">
        <Col className="d-flex align-items-center justify-content-between">
          <h4 className="mb-0">Summary</h4>
          <small className="text-muted">
            Record #{recordNumber}
            {isMostRecent && <span className="ml-2 text-primary">• Most Recent</span>}
          </small>
        </Col>
      </Row>

      <Row>
        <Col lg="6" className="mb-2">
          <InfoRow label="Worker" value={workerName || '--'} />
        </Col>
        <Col lg="6" className="mb-2">
          <InfoRow label="Leave Of Absence Policy" value={loaPolicy || '--'} />
        </Col>
      </Row>

      <Row>
        <Col lg="6" className="mb-2">
          <InfoRow
            label="Estimated Start and End Dates"
            value={
              firstDayOfLoa && lastDayOfLoa
                ? `${toLocaleFormatSlash(firstDayOfLoa)} - ${toLocaleFormatSlash(lastDayOfLoa)}`
                : '--'
            }
          />
        </Col>
        <Col lg="6" className="mb-2">
          <InfoRow
            label="Actual Start and End Dates"
            value={
              actualStartDate && actualEndDate
                ? `${toLocaleFormatSlash(actualStartDate)} - ${toLocaleFormatSlash(actualEndDate)}`
                : '--'
            }
          />
        </Col>
      </Row>

      <Row>
        <Col lg="6" className="mb-2">
          <InfoRow label="Accrual" value={accrual ? 'Yes' : 'No'} />
        </Col>
        <Col lg="6" className="mb-2">
          <InfoRow label="Payment Percentage" value={paymentPct !== undefined ? `${paymentPct}%` : '--'} />
        </Col>
      </Row>

      {selectedReason && (
        <Row>
          <Col lg="12" className="mb-2">
            <InfoRow label="Selected Reason" value={selectedReason} />
          </Col>
        </Row>
      )}

      <Row>
        <Col lg="6" className="mb-2">
          <div className="mb-2 pb-2" style={{ borderBottom: '1px solid #dddddd' }}>
            <div className="text-muted" style={{ fontSize: '0.85rem', marginBottom: '4px' }}>
              Leave Reason
            </div>
            <div style={{ fontSize: '0.95rem', fontWeight: '500', whiteSpace: 'pre-line' }}>{reason || '--'}</div>
          </div>
        </Col>
        <Col lg="6" className="mb-2">
          <div className="mb-2 pb-2" style={{ borderBottom: '1px solid #dddddd' }}>
            <div className="text-muted" style={{ fontSize: '0.85rem', marginBottom: '4px' }}>
              Additional Notes
            </div>
            <div style={{ fontSize: '0.95rem', fontWeight: '500', whiteSpace: 'pre-line' }}>
              {additionalNotes || '--'}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="12" className="mb-2">
          <div className="mb-2 pb-2" style={{ borderBottom: '1px solid #dddddd' }}>
            <div className="text-muted" style={{ fontSize: '0.85rem', marginBottom: '4px' }}>
              Documentation
            </div>
            <div style={{ fontSize: '0.95rem', fontWeight: '500' }}>
              {documents && documents.length > 0
                ? documents.map((doc: any, index: number) => (
                    <div key={index} style={{ fontSize: '0.9rem', marginBottom: '4px' }}>
                      {doc.url ? (
                        <a
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#5e72e4', textDecoration: 'none' }}
                        >
                          <i className="fas fa-file-download mr-1"></i>
                          {doc.originalName || doc.name || 'Document'}
                        </a>
                      ) : (
                        <span>{doc.originalName || doc.name || 'Document'}</span>
                      )}
                    </div>
                  ))
                : '--'}
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default LoaDetailsInfo;
